module.exports = __webpack_public_path__ + "img/reduction_active.fddc98d4.svg";